import React, { forwardRef } from 'react';
import BaseButton from './BaseButton';
import './css/GlyphButton.css';

interface GlyphButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    ariaLabel: string;
    IconComponent: React.ReactNode;
    label?: string;
    labelPosition?: 'left' | 'right';
    tooltipText?: string;
    className?: string;
    viewBox?: string;
    width?: number;
    height?: number;
}

export const GlyphButton = forwardRef<HTMLButtonElement, GlyphButtonProps>(
    (
        {
            ariaLabel,
            IconComponent,
            label,
            labelPosition = 'right',
            tooltipText,
            className = '',
            viewBox = "0 0 32 32",
            width = 32,
            height = 32,
            ...rest
        },
        ref
    ) => {
        return (
            <BaseButton
                ref={ref}
                ariaLabel={ariaLabel}
                className={`svg-button ${className}`}
                tooltipText={tooltipText}
                {...rest}
            >
                <span className="glyph-button-content">
                    {labelPosition === 'left' && label && <span>{label}</span>}
                    {IconComponent}
                    {labelPosition === 'right' && label && <span>{label}</span>}
                </span>
            </BaseButton>
        );
    }
);

export default GlyphButton;
